import { render, staticRenderFns } from "./KeyboardShortcutsSidebar.vue?vue&type=template&id=30354d0a&scoped=true"
import script from "./KeyboardShortcutsSidebar.vue?vue&type=script&lang=js"
export * from "./KeyboardShortcutsSidebar.vue?vue&type=script&lang=js"
import style0 from "./KeyboardShortcutsSidebar.vue?vue&type=style&index=0&id=30354d0a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30354d0a",
  null
  
)

export default component.exports